import React from 'react';
import { DEFAULT_FORMAT } from '@constants';
import { BaseTooltip } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { convertUtcToLocalTime } from '@utils';
import { Button } from 'antd';

const LoginStatusIndicator = ({ lastTimeLogin, translate, fetchedAt }) => {
    const localLastLoginTime = lastTimeLogin
        ? convertUtcToLocalTime(lastTimeLogin, DEFAULT_FORMAT, DEFAULT_FORMAT)
        : null;

    const parseDate = (dateString) => {
        if (!dateString) return null;
        const [datePart, timePart] = dateString.split(' ');
        const [day, month, year] = datePart.split('/');
        return new Date(`${year}-${month}-${day}T${timePart}`);
    };
    let color = 'gray';
    if (localLastLoginTime) {
        const parsedLastLoginTime = parseDate(localLastLoginTime);
        if (
            parsedLastLoginTime instanceof Date &&
            !isNaN(parsedLastLoginTime)
        ) {
            const timeDifference = (fetchedAt - parsedLastLoginTime) / 1000;
            color = timeDifference <= 60 ? '#389e0d' : 'red';
        }
    }
    return (
        <BaseTooltip title={localLastLoginTime || translate.formatMessage(commonMessage.timeLoginNull)}>
            <Button type="link" style={{ padding: 0, color: color, height: '12px' }}>
                <div
                    style={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        backgroundColor: color,
                    }}
                ></div>
            </Button>
        </BaseTooltip>
    );
};

export default LoginStatusIndicator;
